import type { Directive, DirectiveBinding } from "vue";

interface ClickOutsideValue {
  handler: string;
  parameter?: unknown;
}

interface ClickOutsideElement extends HTMLElement {
  COHandler?: (e: Event) => void;
}

type InstanceWithDynamicHandlers = Record<string, (parameter?: unknown) => void>;

const ClickOutside: Directive<HTMLElement, ClickOutsideValue> = {
  beforeMount(el, binding: DirectiveBinding<ClickOutsideValue>) {
    const { handler, parameter } = binding.value;
    const target = el as ClickOutsideElement;

    target.COHandler = (e: Event) => {
      if (!el.contains(e.target as Node)) {
        const instance = binding.instance as unknown as InstanceWithDynamicHandlers;
        instance[handler](parameter);
      }
    };

    document.addEventListener("click", target.COHandler, true);
    document.addEventListener("touchstart", target.COHandler, true);
  },

  unmounted(el) {
    const target = el as ClickOutsideElement;
    if (target.COHandler) {
      document.removeEventListener("click", target.COHandler, true);
      document.removeEventListener("touchstart", target.COHandler, true);
    }
  }
};

export default ClickOutside;
